export default __webpack_public_path__ + "static/media/icon_policy_overview_step2-2.f3fa65e7.svg";